import { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

const Table = (props: ComponentProps<'table'>) => {
  const { className, ...restProps } = props;

  return (
    <div
      data-slot="table-container"
      className="relative w-full overflow-x-auto"
    >
      <table
        data-slot="table"
        className={cn('w-full caption-bottom text-sm', className)}
        {...restProps}
      />
    </div>
  );
};

const TableHeader = (props: ComponentProps<'thead'>) => {
  const { className, ...restProps } = props;

  return (
    <thead
      data-slot="table-header"
      className={cn('[&_tr]:border-b', className)}
      {...restProps}
    />
  );
};

const TableBody = (props: ComponentProps<'tbody'>) => {
  const { className, ...restProps } = props;

  return (
    <tbody
      data-slot="table-body"
      className={cn('[&_tr:last-child]:border-0', className)}
      {...restProps}
    />
  );
};

const TableFooter = (props: ComponentProps<'tfoot'>) => {
  const { className, ...restProps } = props;

  return (
    <tfoot
      data-slot="table-footer"
      className={cn(
        'bg-muted/50 border-t font-medium [&>tr]:last:border-b-0',
        className,
      )}
      {...restProps}
    />
  );
};

const TableRow = (props: ComponentProps<'tr'>) => {
  const { className, ...restProps } = props;

  return (
    <tr
      data-slot="table-row"
      className={cn(
        'hover:bg-muted/50 data-[state=selected]:bg-muted border-b transition-colors',
        className,
      )}
      {...restProps}
    />
  );
};

const TableHead = (props: ComponentProps<'th'>) => {
  const { className, ...restProps } = props;

  return (
    <th
      data-slot="table-head"
      className={cn(
        'text-foreground h-10 px-2 text-left align-middle text-[10px] font-medium whitespace-nowrap uppercase has-[[role=checkbox]]:pr-0 sm:text-xs md:text-sm *:[[role=checkbox]]:translate-y-[2px]',
        className,
      )}
      {...restProps}
    />
  );
};

const TableCell = (props: ComponentProps<'td'>) => {
  const { className, ...restProps } = props;

  return (
    <td
      data-slot="table-cell"
      className={cn(
        'p-2 align-middle wrap-break-word has-[[role=checkbox]]:pr-0 *:[[role=checkbox]]:translate-y-[2px]',
        className,
      )}
      {...restProps}
    />
  );
};

const TableCaption = (props: ComponentProps<'caption'>) => {
  const { className, ...restProps } = props;

  return (
    <caption
      data-slot="table-caption"
      className={cn('text-muted-foreground mt-4 text-sm', className)}
      {...restProps}
    />
  );
};

export {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
};
